/**
 * Derives invite-workers flow step from booking detail flags.
 * Precedence: completed matching → in progress → step 1.
 */
export function getInviteFlowStepFromBooking(booking) {
  if (booking?.hasSmartMatchingComplete) return 3;
  if (booking?.hasSmartMatchingStarted) return 2;
  return 1;
}

export const INVITE_FLOW_STEP_LABELS = {
  1: "Select workers",
  2: "Smart matching",
  3: "Review",
};

/** Earliest scheduled smart-matching start (ISO strings from APIs or booking detail). */
export function earliestSmartMatchingTime(a, b) {
  if (!a) return b ?? null;
  if (!b) return a;
  const ta = new Date(a).getTime();
  const tb = new Date(b).getTime();
  if (!Number.isFinite(ta)) return b;
  if (!Number.isFinite(tb)) return a;
  return ta <= tb ? a : b;
}
